module.exports = __webpack_public_path__ + "img/send-offer-button-mobile-en.df273c9b.jpg";